import {FlowEnum} from 'presentation/pages/private/booking/constants';
import {makeGetAuthCities} from 'main/factories/usecases/private/authorizations';
import {getFeatureFlagValue} from 'infra/http/utils/get-feature-flag-value';
import {FeaturesEnum} from 'presentation/constants';
import {CHANGE_PLAN_LOCATION_FLOW, sortByKey} from 'presentation/utils';
import {
	makeGetCitiesDentalGuide,
	makeGetCitiesMedicalGuide,
	makeGetExamsCities,
	makeGetHealthCities,
} from 'main/factories/usecases';
import {GetCitiesListParam} from './types';
import {CityProps} from '../../types';

export const getCitiesByFlow = async (params: GetCitiesListParam): Promise<CityProps[]> => {
	const {cdUf, flowType, cdPlanoANSOdonto = '', nuRegistroPlano, signal} = params;

	if (flowType === FlowEnum.AUTHORIZATIONS) {
		const isNewFlow = await getFeatureFlagValue(
			FeaturesEnum.PORTAL_FEATURE_LIST_STATE_AND_CITY_AUTOSOL,
		);
		if (isNewFlow && nuRegistroPlano) {
			const response = await makeGetCitiesMedicalGuide().get({
				cdPlanoANS: nuRegistroPlano.toUpperCase(),
				cdUf,
				signal,
			});
			return sortByKey(response.cidades ?? [], 'nmCidade');
		}
		const response = await makeGetAuthCities().get({uf: cdUf, signal});
		const data = 'items' in response ? (response.items ?? []) : response;
		return sortByKey(data ?? [], 'nmCidade');
	}

	if (flowType === FlowEnum.ODONTO || flowType === FlowEnum.ODONTO_GUIDE) {
		if (!cdPlanoANSOdonto.length) return [];
		const response = await makeGetCitiesDentalGuide().get({
			cdPlanoANS: cdPlanoANSOdonto,
			cdUf,
			signal,
		});
		return sortByKey(response?.cidades ?? [], 'nmCidade');
	}

	if (flowType === FlowEnum.EXAM) {
		const response = await makeGetExamsCities().get({cdUf, signal});
		return sortByKey(response?.cidades ?? [], 'nmCidade');
	}

	if (flowType === FlowEnum.HEALTH_GUIDE || flowType === CHANGE_PLAN_LOCATION_FLOW) {
		if (!nuRegistroPlano) {
			throw new Error('Número de registro do plano é obrigatório');
		}
		const response = await makeGetCitiesMedicalGuide().get({
			cdPlanoANS: nuRegistroPlano.toUpperCase(),
			cdUf,
			signal,
		});
		if (!response.cidades || response.cidades.length === 0) {
			return [];
		}
		return response.cidades;
	}

	const response = await makeGetHealthCities().get({state_code: cdUf, signal});
	const sorted = sortByKey(response?.content ?? [], 'city');
	return sorted.map(item => ({nmCidade: item.city}));
};
